import type { ProductsData } from '@/app/api/search/products/createProductsData.ts';
import { SortValues } from '@/app/common/memsearch/types.ts';
import { APIStatusEnum } from './APIStatusEnum';

export const productsDataDefault: ProductsData = {
  dealCards: [],
  productCounters: {
    productsCount: 0,
    productsCountAlternative: 0,
    productsCountTo: 0,
    productsCountBookNowPayLater: 0,
    productsPackageDiscountAvailable: 0,
    productsPackageDiscountEnabled: 0,
    productsResultsBeforeMapFilterCnt: 0,
    productsPriceStats: {
      absoluteCheapestPrice: 0,
      cheapestPriceFirstPage: 0,
      firstPriceBySorting: 0,
    },
    productsCountPlus: 0,
  },
  flags: {
    voucherExtra: false,
    opxFlexibleDates: false,
    apex: false,
  },
  dots: [],
  apiStatus: APIStatusEnum.NORESULTS,
  message: '',
  vcSearchId: '',
  bookingWindow: 0,
  businessProfileSearchResponse: '',
  rankingBusinessProfile: '',
  debugData: {},
  defaultSearch: {
    destination: '',
    dateFrom: '',
    dateTo: '',
    adults: '',
    sort: SortValues.Recommended,
    origin: '',
  },
  instantSearch: false,
  apexAvailabilityFlag: false,
};
